import { render } from "./page-tentang-kami.vue?vue&type=template&id=682cd4cd&scoped=true"
import script from "./page-tentang-kami.vue?vue&type=script&lang=js"
export * from "./page-tentang-kami.vue?vue&type=script&lang=js"

import "./page-tentang-kami.vue?vue&type=style&index=0&id=682cd4cd&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682cd4cd"]])

export default __exports__